import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Modal, Alert, Button, Form } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const EditarCuentaModal = ({ handleClose, show, idEdicion, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const [buscando, setBuscando] = React.useState(true)

  const infoDetalleAsientoRef = React.useRef(null)

  React.useEffect(() => {
    AsientoContableService.obtenerDetallexIdAsInfoCuenta(idEdicion)
      .then(({ data }) => {
        if (data) {
          infoDetalleAsientoRef.current = {
            cuentaContable: data.cuentaContable,
            cuentaContableInfo: data.cuentaContableInfo
          }
        }
      })
      .catch(() => {
        infoDetalleAsientoRef.current = null
      })
      .finally(() => {
        setBuscando(false)
      })
  }, [idEdicion])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      AsientoContableService.actualizarDetallexIdAsCuentaContable(idEdicion, data)
        .then(() => {
          __zariContext.snack('success', 'Se ha actualizado los datos.')
          reloadTable()
          handleClose()
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, idEdicion, reloadTable, handleClose]
  )

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Editar cuenta contable</Modal.Title>
      </Modal.Header>
      {buscando ? (
        <>
          <Modal.Body>
            <Alert color='info'>Obteniendo información.</Alert>
          </Modal.Body>
          <Modal.Footer>
            <Button color='secondary' outline onClick={handleClose}>
              Cancelar
            </Button>
          </Modal.Footer>
        </>
      ) : (
        <>
          {infoDetalleAsientoRef.current ? (
            <Formik initialValues={infoDetalleAsientoRef.current} onSubmit={onSubmit}>
              {({ handleSubmit, values, errors, touched, setFieldValue }) => (
                <>
                  <Modal.Body>
                    <Form>
                      <FormGroups.CuentaContableFormGroup
                        iError={errors.cuentaContable}
                        iTouched={touched.cuentaContable}
                        iValue={values.cuentaContableInfo}
                        setFieldValue={setFieldValue}
                      />
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button color='secondary' outline onClick={handleClose}>
                      Cancelar
                    </Button>
                    <Button onClick={handleSubmit}>Guardar</Button>
                  </Modal.Footer>
                </>
              )}
            </Formik>
          ) : (
            <>
              <Modal.Body>
                <Alert color='danger'>No se pudo obtener información del detalle.</Alert>
              </Modal.Body>
              <Modal.Footer>
                <Button color='secondary' outline onClick={handleClose}>
                  Cancelar
                </Button>
              </Modal.Footer>
            </>
          )}
        </>
      )}
    </Modal>
  )
}

export default React.memo(EditarCuentaModal)
